import { render, staticRenderFns } from "./VideoDescBottom.vue?vue&type=template&id=ac45981c&scoped=true"
import script from "./VideoDescBottom.vue?vue&type=script&lang=js"
export * from "./VideoDescBottom.vue?vue&type=script&lang=js"
import style0 from "./VideoDescBottom.vue?vue&type=style&index=0&id=ac45981c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac45981c",
  null
  
)

export default component.exports